import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="gift-box, present" maskId="round-filled-radius-1-stroke-1.5-IconGiftBox"><path d="M2 5.75C2 4.7835 2.7835 4 3.75 4H11.25V9H3.75C2.7835 9 2 8.2165 2 7.25V5.75Z" fill="currentColor"/><path d="M3 10.5H11.25V20H4.75C3.7835 20 3 19.2165 3 18.25V10.5Z" fill="currentColor"/><path d="M12.75 4H20.25C21.2165 4 22 4.7835 22 5.75V7.25C22 8.2165 21.2165 9 20.25 9H12.75V4Z" fill="currentColor"/><path d="M12.75 10.5H21V18.25C21 19.2165 20.2165 20 19.25 20H12.75V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftBox;
